/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { Box, Typography, Stack } from "@mui/material";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { getAPICall } from "lib/callApi";
import {
  fetchDateRangeForWidget,
  formatDatesForWidget,
  handlePeriodsForWidget,
} from "utils/HelperFunctions";
import "../styles/widget.scss";
import TooltipLight from "utils/TooltipLight";
import CustomizePointGoalModal from "./CustomizePointGoalModal";

export default function PointGoal({ widget, updateWidgetMetadata }) {
  // const { refresh: refreshKpiWidget, kpiActionId: refreshKpi } = useSelector(
  //   (state) => state.home.kpiWidgets
  // );
  const { dataSource, widgetTitle, isCustomizable, title, timePeriod, pointGoal } = widget;
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const [periodDates, setPeriodDates] = useState({});
  const [data, setData] = useState({ goalAchievedDays: 0, workingDays: 0, workingDaysInPeriod: 0 });
  const [widgetOptions, setWidgetOptions] = useState({
    title: title || widgetTitle || "Point Goal",
    timePeriod: timePeriod || "monthly",
    pointGoal: pointGoal || 10,
  });
  const [open, setOpen] = useState(false);

  const handleCloseModal = () => setOpen(false);
  const handleOpenModal = async () => {
    setOpen(true);
  };
  const handleModalSave = (options) => {
    setWidgetOptions(options);
    setPeriodDates(fetchDateRangeForWidget(options.timePeriod, loginUser.fiscalYearStart));
    updateWidgetMetadata(widget.gridKey, options);
  };

  const handlePeriods = (type) => {
    if (!periodDates.start && !periodDates.end) return;
    const dates = handlePeriodsForWidget(type, widgetOptions.timePeriod, periodDates);
    if (
      dates.start &&
      dates.end &&
      dates.start !== periodDates.start &&
      dates.end !== periodDates.end
    ) {
      setPeriodDates(dates);
    }
  };

  const fetchData = async () => {
    if (dataSource && periodDates.start && periodDates.end) {
      let payload = {
        start: periodDates.start,
        end: periodDates.end,
      };
      if (isCustomizable) {
        if (widgetOptions.pointGoal === undefined) {
          return;
        }
        payload = { ...payload, pointGoal: widgetOptions.pointGoal };
      }
      const result = await getAPICall(dataSource, true, payload);
      if (result?.data?.success) {
        setData(result.data.data);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [periodDates, widgetOptions]);

  useEffect(() => {
    const dates = fetchDateRangeForWidget(widgetOptions.timePeriod, loginUser.fiscalYearStart);
    setPeriodDates(dates);
  }, []);

  return (
    <>
      <Stack
        p={2}
        sx={{
          overflowY: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
          height: "100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              color="info"
              mb={0}
              // display="block"
              className="dragHandle"
              lineHeight="1rem"
            >
              {widgetOptions.title}
            </Typography>
            <Typography
              variant="h6"
              color="info"
              mb={0}
              lineHeight="1rem"
              sx={{
                fontSize: "0.75rem",
                color: "#888",
              }}
            >
              {`${widgetOptions.pointGoal} points`}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              pl: "0.15rem",
            }}
          >
            {isCustomizable && (
              <Box
                sx={{
                  width: "100%",
                  my: "-2px",
                }}
              >
                <TooltipLight title="Customize this widget" placement="left" variant="outline">
                  <MoreHorizIcon
                    style={{ cursor: "pointer", float: "right" }}
                    onClick={() => handleOpenModal()}
                  />
                </TooltipLight>
              </Box>
            )}

            {periodDates.start && (
              <Box
                sx={{
                  fontSize: "20px",
                  display: "flex",
                  alignItems: "center",
                  mx: "-10px",
                }}
              >
                <ArrowLeft
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePeriods("prev")}
                  sx={{
                    mr: "-3px",
                  }}
                />
                <Typography variant="caption" color="info" mb={0} display="block">
                  {formatDatesForWidget(
                    widgetOptions.timePeriod,
                    periodDates,
                    loginUser.fiscalYearStart
                  )}
                </Typography>
                <ArrowRight
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePeriods("next")}
                  sx={{
                    ml: "-3px",
                  }}
                />
              </Box>
            )}
          </Box>
        </Box>

        <Stack
          direction="column"
          sx={{
            width: "100%",
            justifyContent: "center",
            flexGrow: 1,
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="h1" color="info" mb={0} lineHeight={1}>
              {data.goalAchievedDays}
            </Typography>
            <Typography
              fontSize="0.8rem"
              color="#666"
              ml={1}
            >{`/ ${data.workingDays} days`}</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography fontSize="1rem" fontWeight="600" pr={0.5} color="#f8a83c">
              {data.workingDaysInPeriod - data.workingDays}
            </Typography>
            <Typography fontSize="0.9rem" color="#aaa" lineHeight="0.8rem">
              days remaining
            </Typography>
          </Box>
        </Stack>
      </Stack>
      {open && (
        <CustomizePointGoalModal
          open={open}
          handleClose={handleCloseModal}
          handleSave={handleModalSave}
          widgetOptions={widgetOptions}
        />
      )}
    </>
  );
}
